import request from '@/utils/request'

// 查询商品分类信息列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/prod/sku/svc/page',
        method: 'get',
        params: query,
    })
}

export function delObj(data) {
    return request({
        url: '/upkeep/prod/sku/svc/delete',
        method: 'post',
        data: data,
    })
}

// 更改状态
export function statusObj(data) {
    return request({
        url: '/upkeep/prod/sku/svc/status',
        method: 'post',
        data: data,
    })
}

export function getObj(id) {
    return request({
        url: '/upkeep/prod/sku/svc/detail?id=' + id,
        method: 'get',
    })
}
// 新增商品分类
export function addObj(data) {
    return request({
        url: '/upkeep/prod/sku/svc/add',
        method: 'post',
        data: data,
    })
}

// 修改商品分类
export function putObj(data) {
    return request({
        url: '/upkeep/material/edit',
        method: 'post',
        data: data,
    })
}
